// Dynamic API_BASE_URL detection:
// - On localhost/127.0.0.1 -> http://127.0.0.1:8000
// - On production domain (frigidercomunitar.md) -> https://back.frigidercomunitar.md
export const getApiBaseUrl = () => {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';
    }
    return 'https://back.frigidercomunitar.md';
  }
  return 'https://back.frigidercomunitar.md';
};

export const API_BASE_URL = getApiBaseUrl();
